import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Restricts customer-only routes (browsing restaurants, cart, checkout, etc.)
 * for staff accounts. Drivers, restaurant owners, and admins are auto-redirected
 * to their dedicated dashboards so they can't act as customers.
 */
export default function CustomerOnlyRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-[#E05D3A] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (user?.is_driver) return <Navigate to="/driver" replace />;
  if (user?.is_restaurant_owner) return <Navigate to="/owner" replace />;
  if (user?.is_admin) return <Navigate to="/admin" replace />;

  return children;
}
